import { FiCalendar, FiCheckCircle, FiClipboard, FiCoffee, FiEdit3, FiHome, FiMap, FiMessageSquare, FiMonitor, FiStar, FiUsers, FiVideo } from 'react-icons/fi';
import { PiStudent, PiTreeStructureLight } from 'react-icons/pi';
import { TbPhotoUp } from 'react-icons/tb';
import { BsBoxes, BsFileEarmarkCheck } from 'react-icons/bs';
import { VscGame } from 'react-icons/vsc';
import monitor from './img/monitor.svg';
import organization from './img/organization.svg';
import chart from './img/chart.svg';
import check from './img/check.svg';
import activity from './img/activity.svg';
import message from './img/message.svg';
import IconPerformance from '@/components/custom/icons/IconPerformance';
import IconExercises from '@/components/custom/icons/IconExercises';
import IconExams from '@/components/custom/icons/IconExams';
import IconSimulated from '@/components/custom/icons/IconSimulated';

export function adminMenu({ session, abilities, checkPermission }) {
  const appName = process.env.REACT_APP_NAME;

  const ViewLiveClass = checkPermission(session, 'Visualizar aulas ao vivo', 'Aulas ao vivo');
  const viewLessonPlan = checkPermission(session, 'Visualizar Plano de Aula', 'Plano de Aula');
  const viewCourse = checkPermission(session, 'Visualizar lista de cursos', 'Cursos');
  const viewClassroom = checkPermission(session, 'Visualizar lista de turmas', 'Turmas');
  const viewTaxonomies = checkPermission(session, 'Visualizar lista de ementas, tópicos e subtópicos', 'Ementas');
  const viewMetrics =
    checkPermission(session, 'Visualizar dados e métricas', 'Questionário de Percepção') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Projetos') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Participantes e perfis administrativos') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Arquivos e atividades complementares') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Questões e exercícios') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Provas e simulados') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Ementas') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Fórum') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Cursos') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Turmas') ||
    checkPermission(session, 'Visualizar dados e métricas', 'Tarefas');

  return [
    {
      id: 1,
      route: '/',
      icon: <FiHome />,
      label: 'Home'
    },
    {
      id: 2,
      icon: <FiMonitor />,
      submenu: {
        img: monitor,
        title: 'Cursos e Aulas',
        subtitle: 'Videoaulas, material didático e aulas ao vivo',
        nav: [
          {
            route: '/curso/admin',
            icon: <FiMonitor />,
            title: 'Cursos',
            description: 'Aulas e materiais complementares',
            visible: abilities?.cursos
          },
          {
            route: '/aulas-ao-vivo',
            icon: <FiVideo />,
            title: 'Aulas ao vivo',
            description: 'Sessões interativas em tempo real',
            visible: abilities?.['aulas-ao-vivo'] && ViewLiveClass
          },
          {
            route: '/plano-de-aulas/inicio',
            icon: <FiMap />,
            title: 'Planos de aula',
            description: 'Gerencie guias de aula estruturadas',
            visible: viewLessonPlan && abilities?.['plano-de-aula']
          },
          {
            route: '/grade-horaria',
            icon: <FiMap />,
            title: 'Grade horária',
            description: 'Visualize horários das aulas ao vivo',
            visible: appName === 'canaleducacao'
          }
        ]
      }
    },
    {
      id: 3,
      icon: <BsBoxes style={{ strokeWidth: 0 }} />,
      submenu: {
        img: organization,
        title: 'Organização da Plataforma',
        subtitle: 'Gerenciamento de turmas, usuários e estrutura de conteúdo',
        nav: [
          {
            route: '/turmas',
            icon: <PiStudent />,
            title: 'Turmas',
            description: 'Crie e gerencie turmas e alunos',
            visible: (viewCourse || viewClassroom) && abilities?.cursos
          },
          {
            route: '/participantes',
            icon: <FiUsers />,
            title: 'Usuários',
            description: 'Crie e gerencie perfis e usuários',
            visible:
              checkPermission(session, 'Visualizar lista de participantes', 'Participantes e perfis administrativos') ||
              checkPermission(session, 'Visualizar lista e gerenciar perfis', 'Participantes e perfis administrativos') ||
              checkPermission(session, 'Enviar notificações de engajamento', 'Participantes e perfis administrativos')
          },
          {
            route: '/ementa/materias',
            icon: <PiTreeStructureLight />,
            title: 'Ementa',
            description: 'Defina a estrutura do conteúdo pedagógico',
            visible: viewTaxonomies
          },
          {
            route: '/banners',
            icon: <TbPhotoUp />,
            title: 'Banner informativo',
            description: 'Mostre banners informativos para diversos perfis',
            visible: viewTaxonomies
          }
        ]
      }
    },
    {
      id: 4,
      icon: <IconPerformance />,
      submenu: {
        img: chart,
        title: 'Análise',
        subtitle: 'Acompanhe e analise os resultados de aprendizado.',
        nav: [
          {
            route: '/metricas/institucional',
            icon: <IconPerformance />,
            title: 'Relatórios',
            description: 'Acompanhe a performance, cadastro, engajamento e mais',
            visible: viewMetrics && abilities?.metricas
          }
        ]
      }
    },
    {
      id: 5,
      icon: <FiCheckCircle />,
      submenu: {
        img: check,
        title: 'Ferramentas de Avaliação',
        subtitle: 'Teste conhecimentos e monitore resultados',
        nav: [
          {
            route: '/avaliacoes/banco-de-questoes',
            icon: <FiCheckCircle />,
            title: 'Banco de questões',
            description: 'Repositório para avaliação e exercícios',
            visible:
              (checkPermission(session, 'Visualizar lista de provas', 'Provas e simulados') ||
                checkPermission(session, 'Visualizar banco de questões', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar exercícios', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar resultados', 'Provas e simulados')) &&
              abilities?.avaliacoes
          },
          {
            route: '/avaliacoes/apostilas',
            icon: <IconExercises />,
            title: 'Exercícios',
            description: 'Crie e gerencie cadernos de exercícios',
            visible:
              (checkPermission(session, 'Visualizar lista de provas', 'Provas e simulados') ||
                checkPermission(session, 'Visualizar banco de questões', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar exercícios', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar resultados', 'Provas e simulados')) &&
              abilities?.avaliacoes
          },
          {
            route: '/avaliacoes/provas',
            icon: <IconExams />,
            title: 'Provas',
            description: 'Avalie o conhecimento dos estudantes',
            visible:
              (checkPermission(session, 'Visualizar lista de provas', 'Provas e simulados') ||
                checkPermission(session, 'Visualizar banco de questões', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar exercícios', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar resultados', 'Provas e simulados')) &&
              abilities?.avaliacoes
          },
          {
            route: '/avaliacoes/simulados',
            icon: <IconSimulated />,
            title: 'Simulados',
            description: 'Crie avaliações simulando exames reais',
            visible:
              (checkPermission(session, 'Visualizar lista de provas', 'Provas e simulados') ||
                checkPermission(session, 'Visualizar banco de questões', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar exercícios', 'Questões e exercícios') ||
                checkPermission(session, 'Visualizar resultados', 'Provas e simulados')) &&
              abilities?.avaliacoes
          },
          {
            route: '/questionario',
            icon: <FiStar />,
            title: 'Questionário de percepção',
            description: 'Colete feedback dos estudantes',
            visible: checkPermission(session, 'Visualizar questionário de percepção', 'Questionário de Percepção') && abilities?.nps
          }
        ]
      }
    },
    {
      id: 6,
      icon: <FiEdit3 />,
      submenu: {
        img: activity,
        title: 'Atividades',
        subtitle: 'Enriqueça a experiência de aprendizado',
        nav: [
          {
            route: '/gestao-de-tarefa/curso',
            icon: <FiCalendar />,
            title: 'Tarefas',
            description: 'Crie e atribua tarefas aos estudantes',
            visible: checkPermission(session, 'Visualizar Tarefas', 'Tarefas') && abilities?.tarefas
          },
          {
            route: '/atividade-complementar',
            icon: <BsFileEarmarkCheck />,
            title: 'Atividade Complementar',
            description: 'Ofereça atividades de estudo individuais',
            visible: checkPermission(session, 'Visualizar lista de atividades', 'Arquivos e atividades complementares') && abilities?.['cursos-ativ-complementar']
          },
          {
            route: '/desafio-da-semana/desafios',
            icon: <VscGame strokeWidth={0.6} />,
            title: 'Desafio da semana',
            description: 'Elabore disputas de conhecimento para os estudantes',
            visible: abilities?.['desafio-da-semana']
          },
          {
            route: '/redacao',
            icon: <FiEdit3 />,
            title: 'Redação',
            description: 'Atribua e avalie as habilidades de escrita dos estudantes.',
            visible: abilities?.redacao
          },
          {
            route: '/projetos/grupos',
            icon: <FiClipboard />,
            title: 'Projetos',
            description: 'Crie e acompanhe a evolução de  trabalhos colaborativo',
            visible: checkPermission(session, 'Visualizar lista de projetos', 'Projetos') && abilities?.projetos
          }
        ]
      }
    },
    {
      id: 7,
      icon: <FiMessageSquare />,
      submenu: {
        img: message,
        title: 'Comunidade',
        subtitle: 'Aqui todos se reúnem para partilhar e aprender',
        nav: [
          {
            route: '/auditorio',
            icon: <FiMessageSquare />,
            title: 'Monitoria',
            description: 'Forneça orientação em tempo real',
            visible: abilities?.auditorio && checkPermission(session, 'Visualizar monitorias', 'Monitorias')
          },
          {
            route: '/feed',
            icon: <FiCoffee />,
            title: 'Fórum',
            description: 'Troque experiências com alunos e outros professores',
            visible: checkPermission(session, 'Visualizar postagens e comentários', 'Fórum') && abilities?.feed
          }
        ]
      }
    }
  ];
}
